var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count)?_c('span',{class:[
    'pending-count-badge',
    ("pending-count-badge--" + _vm.tier),
    _vm.variant === 'avatar' ? 'pending-count-badge--avatar' : '' ]},[_vm._v(_vm._s(_vm.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }